document.addEventListener('DOMContentLoaded', () => {
  const url = window.location.href;

  // Show Klaviyo popup only if form was submitted successfully
  const showPopup = url.includes('?customer_posted=true') && url.includes('#contact_form');

  if (showPopup) {
    const isGerman = window.location.pathname.includes('/de');
    const isMobile = window.innerWidth < 768;

    let popupId;

    if (isGerman) {
      popupId = isMobile ? 'UBAjTd' : 'XDt4AA';
    } else {
      popupId = isMobile ? 'TMx2sJ' : 'VxzTMM';
    }

    // Wait a short time for Klaviyo to initialize (just in case)
    const openKlaviyoPopup = () => {
      if (window._klOnsite) {
        window._klOnsite.push(['openForm', popupId]);
      } else {
        console.error('Klaviyo onsite script not loaded');
      }
    };

    // Delay slightly to ensure Klaviyo is ready
    setTimeout(openKlaviyoPopup, 500);
  }



  // const modal = document.getElementById('newsletter-modal');
  // const overlay = document.getElementById('overlay');
  // const closeBtn = document.getElementById('close-button');
  // const shopButtons = document.querySelectorAll('.shop-button');

  // // Check if URL contains specific parameter
  // if (window.location.href.includes('?customer_posted=true#contact_form') || window.location.href.includes('customer#contact_form')) {
  //   // Show popup and overlay
  //   modal.classList.add('is-visible');
  //   overlay.classList.add('is-visible');
  //   document.body.style.overflow = 'hidden';
  // }

  // // Function to close popup
  // function closePopup() {
  //   modal.classList.remove('is-visible');
  //   overlay.classList.remove('is-visible');
  //   document.body.style.overflow = 'auto';
  // }

  // // Close popup when clicking close button or overlay
  // closeBtn.addEventListener('click', closePopup);
  // overlay.addEventListener('click', closePopup);

  // // Close popup when clicking 'Shop Now' button
  // shopButtons.forEach(button => {
  //   button.addEventListener('click', closePopup);
  // });
});